import { render, staticRenderFns } from "./CreateNonTrade.vue?vue&type=template&id=1eaa6c16&"
import script from "./CreateNonTrade.vue?vue&type=script&lang=js&"
export * from "./CreateNonTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports